import useAxios from 'axios-hooks';

export interface IUploadImage {
  id?: number | null;
  fileNameTh: string;
  fileNameEn: string;
  descriptionTh: string;
  descriptionEn: string;
  urlTh: string;
  urlEn: string;
  isUseSameFile: boolean;
  sequence: number;
  markedForDeletion?: boolean;
  fileNameThForDeletion?: string;
  fileNameEnForDeletion?: string;
}

export interface IResponseImage {
  imageUrl: string;
  imagename: string;
  sequence: number;
}

export const useUploadImage = (id: number) => {
  const [{ data, loading, error }, execute] = useAxios(
    {
      url: `image/upload`,
      method: 'POST',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
    { manual: true }
  );

  const uploadImage = async (
    file: File,
    index: number,
    name: string,
    locale: string
  ) => {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('sequence', (index + 1).toString());
    formData.append('language', locale);

    const sectionName = name
      .replace(/\.(\w)/g, (_, c) => c.toUpperCase())
      .replace(/\d+$/, '');
    formData.append('sectionName', sectionName);

    const response = await execute({
      url: `/image/upload/${id}`,
      data: formData,
    });

    return response.data;
  };

  return { uploadImage, data, loading, error };
};

export const useDeleteImage = (id: number) => {
  const [{ data, loading, error }, execute] = useAxios(
    { method: 'DELETE' },
    { manual: true }
  );

  const deleteImage = async (
    sectionName: string,
    fileNameTh?: string | undefined,
    fileNameEn?: string | undefined
  ) => {
    if (!fileNameTh && !fileNameEn) {
      return;
    }

    if (fileNameTh) {
      const urlTh = `/image/delete/${id}/${sectionName}/${fileNameTh}`;
      await execute({ url: urlTh });
    }

    if (fileNameEn) {
      const urlEn = `/image/delete/${id}/${sectionName}/${fileNameEn}`;
      await execute({ url: urlEn });
    }
  };

  return { deleteImage, data, loading, error };
};

export const deleteAssets = (
  sectionName: string,
  assets: Array<{
    fileNameThForDeletion?: string;
    fileNameEnForDeletion?: string;
  }>,
  deleteImage: (
    sectionName: string,
    fileNameTh?: string,
    fileNameEn?: string
  ) => void
) => {
  if (assets?.length) {
    for (const asset of assets) {
      const { fileNameThForDeletion, fileNameEnForDeletion } = asset;

      if (fileNameThForDeletion && fileNameEnForDeletion) {
        deleteImage(sectionName, fileNameThForDeletion, fileNameEnForDeletion);
      } else if (fileNameThForDeletion) {
        deleteImage(sectionName, fileNameThForDeletion);
      } else if (fileNameEnForDeletion) {
        deleteImage(sectionName, fileNameEnForDeletion);
      }
    }
  }
};
